export const constants = {
    mpdConstant: {
        CREAT_MPD: "CREAT_MPD",
        MPD_CREATED: "MPD_CREATED",
        MPD_CREATION_FAILED: "MPD_CREATION_FAILED",

        MPD_FETCHED_ALL_WITH_PRODUCT: " MPD_FETCHED_ALL_WITH_PRODUCT",
        MPD_FETCHED_FAILED: "MPD_FETCH_FAILED",
        MPD_FETCHED_ALL: "FETCHED_ALL_MPD",
        MPD_STORE_CHANGE: "MPD_STORE_CHANGE"
    },
    nozzelConstant: {
        CREAT_NOZZEL: "CREAT_NOZZEL",
        NOZZEL_CREATED: "NOZZEL_CREATED",
        NOZZEL_CREATION_FAILED: "NOZZEL_CREATION_FAILED",

        NOZZEL_FETCH_FAILED: "NOZZEL_FETCH_FAILED",
        NOZZEL_FETCH_ALL: "NOZZEL_FETCH_ALL",

        NOZZEL_STORE_CHANGE: "NOZZEL_STORE_CHANGE"
    },
    productConstant: {
        CREATE_PRODUCT: "CREATE_PRODUCT",
        PRODUCT_CREATED: "PRODUCT_CREATED",
        PRODUCT_CREATION_FAILED: "PRODUCT_CREATION_FAILED",

        FETCHED_ALL_PRODUCTS: "FETCHED_ALL_PRODUCTS",
        PRODUCTS_FETCH_FAILED: "PRODUCTS_FETCH_FAILED",

        PRODUCTS_STORE_CHANGE: "PRODUCTS_STORE_CHANGE"
    },
    tankConstant: {
        CREATE_TANK: "CREATE_TANK",

        TANK_CREATED: "TANK_CREATED",
        TANK_CREATION_FAILED: "TANK_CREATION_FAILED",

        FETCHED_ALL_TANKS: "FETCHED_ALL_TANKS",
        TANK_FETCH_FAILED: "TANK_FETCH_FAILED",

        TANK_STORE_CHANGE: "TANK_STORE_CHANGE",

        FETCHED_ALL_DIP_TABLE: "  FETCHED_ALL_DIP_TABLE",
        DIP_TABLE_FETCH_FAILED: " DIP_TABLE_FETCH_FAILED",

    },
    stockInConstant: {
        CREATE_STOCKIN: "CREATE_STOCKIN",

        STOCKIN_CREATED: " STOCKIN_CREATED",
        STOCKIN_CREATION_FAILED: "STOCKIN_CREATION_FAILED",

        FETCHED_ALL_STOCKIN: "FETCHED_ALL_ STOCKIN",
        STOCKIN_FETCH_FAILED: "STOCKIN_FETCH_FAILED",

        STOCKIN_STORE_CHANGE: "STOCKIN_STORE_CHANGE"
    },

    userConstant: {
        CREATE_USER: "CREATE_USER",

        USER_CREATED: "USER_CREATED",
        USER_CREATION_FAILED: "USER_CREATION_FAILED",

        FETCHED_ALL_USER: "FETCHED_ALL_USER",
        USER_FETCH_FAILED: "USER_FETCH_FAILED",

        USER_STORE_CHANGE: "USER_STORE_CHANGE"
    },
    shiftConstant: {
        CREATE_SHIFT: "CREATE_SHIFT",

        SHIFT_CREATED: "SHIFT_CREATED",
        SHIFT_CREATION_FAILED: "SHIFT_CREATION_FAILED",

        FETCHED_ALL_SHIFT: "FETCHED_ALL_SHIFT",
        SHIFT_FETCH_FAILED: "SHIFT_FETCH_FAILED",

        SHIFT_STORE_CHANGE: "SHIFT_STORE_CHANGE",

        NEW_SHIFT_STARTED: "NEW_SHIFT_STARTED",
        NEW_SHIFT_FAILED: "NEW_SHIFT_FAILED"
    },
    employeeConstant: {
        CREATE_EMPLOYEE: "CREATE_EMPLOYEE",

        EMPLOYEE_CREATED: "EMPLOYEE_CREATED",
        EMPLOYEE_CREATION_FAILED: "EMPLOYEE_CREATION_FAILED",

        FETCHED_ALL_EMPLOYEE: "FETCHED_ALL_EMPLOYEE",
        EMPLOYEE_FETCH_FAILED: "EMPLOYEE_FETCH_FAILED",

        EMPLOYEE_STORE_CHANGE: "EMPLOYEE_STORE_CHANGE"
    },
    employeeAdvanceConstant: {
        CREATE_EMPLOYEE_ADVANCE: "CREATE_EMPLOYEE_ADVANCE",

        EMPLOYEE_ADVANCE_CREATED: "EMPLOYEE_ADVANCE_CREATED",
        EMPLOYEE_ADVANCE_CREATION_FAILED: "EMPLOYEE_ADVANCE_CREATION_FAILED",

        FETCHED_ALL_EMPLOYEE_ADVANCE: "FETCHED_ALL_EMPLOYEE_ADVANCE",
        EMPLOYEE_ADVANCE_FETCH_FAILED: "EMPLOYEE_ADVANCE_FETCH_FAILED",

        EMPLOYEE_ADVANCE_STORE_CHANGE: "EMPLOYEE_ADVANCE_STORE_CHANGE"
    },

    invoiceConstant: {
        INVOICE_CREATED: "INVOICE_CREATED",
        INVOICE_CREATION_FAILED: "INVOICE_CREATION_FAILED"
    },
    creditorConstant: {
        CREATE_CREDITOR: "CREATE_CREDITOR",

        CREDITOR_CREATED: "CREDITOR_CREATED",
        CREDITOR_CREATION_FAILED: "CREDITOR_CREATION_FAILED",

        FETCHED_ALL_CREDITOR: "FETCHED_ALL_CREDITOR",
        CREDITOR_FETCH_FAILED: "CREDITOR_FETCH_FAILED",

        CREDITOR_STORE_CHANGE: "CREDITOR_STORE_CHANGE",

        UPDATE_CREDITOR: "UPDATE_CREDITOR",
        UPDATE_CREDITOR_CREATION_FAILED: "UPDATE_CREDITOR_CREATION_FAILED"

    },
    productRateConstant: {
        CREATE_PRODUCTRATE: "CREATE_PRODUCTRATE",

        PRODUCTRATE_CREATED: "PRODUCTRATEPRODUCTRATE_CREATED",
        PRODUCTRATE_CREATION_FAILED: "PRODUCTRATE_CREATION_FAILED",

        FETCHED_ALL_PRODUCTRATE: "FETCHED_ALL_PRODUCTRATE",
        PRODUCTRATE_FETCH_FAILED: "PRODUCTRATE_FETCH_FAILED",

        PRODUCTRATE_STORE_CHANGE: "PRODUCTRATE_STORE_CHANGE"
    },


    expenditureCatagoryConstant: {
        CREATE_EXPENDITURECATAGORY: "CREATE_EXPENDITURECATAGORY",

        EXPENDITURECATAGORY_CREATED: "EXPENDITURECATAGORY_CREATED",
        EXPENDITURECATAGORY_CREATION_FAILED: "EXPENDITURECATAGORY_CREATION_FAILED",

        FETCHED_ALL_EXPENDITURECATAGORY: "FETCHED_ALL_EXPENDITURECATAGORY",
        EXPENDITURECATAGORY_FETCH_FAILED: "EXPENDITURECATAGORY_FETCH_FAILED",

        EXPENDITURECATAGORY_STORE_CHANGE: "EXPENDITURECATAGORY_STORE_CHANGE",

    },

    transactionAccountConstant: {
        CREATE_TRANSACTIONACCOUNT: "CREATE_TRANSACTIONACCOUNT",

        TRANSACTIONACCOUNT_CREATED: "TRANSACTIONACCOUNT_CREATED",
        TRANSACTIONACCOUNT_CREATION_FAILED: "TRANSACTIONACCOUNT_CREATION_FAILED",

        FETCHED_ALL_TRANSACTIONACCOUNT: "FETCHED_ALL_TRANSACTIONACCOUNT",
        FETCHED_ALL_TRANSACTION_PAYMENT: "FETCHED_ALL_TRANSACTION_PAYMENT",
        TRANSACTIONACCOUNT_FETCH_FAILED: "TRANSACTIONACCOUNT_FETCH_FAILED",

        TRANSACTIONACCOUNT_STORE_CHANGE: "TRANSACTIONACCOUNT_STORE_CHANGE"
    },


    paymentModeConstant: {
        CREATE_PAYMENTMODE: "CREATE_ PAYMENTMODE",

        PAYMENTMODE_CREATED: " PAYMENTMODE_CREATED",
        PAYMENTMODE_CREATION_FAILED: " PAYMENTMODE_CREATION_FAILED",

        FETCHED_ALL_PAYMENTMODE: "FETCHED_ALL_ PAYMENTMODE",
        PAYMENTMODE_FETCH_FAILED: " PAYMENTMODE_FETCH_FAILED",

        PAYMENTMODE_STORE_CHANGE: " PAYMENTMODE_STORE_CHANGE"
    },
    swipeMachineConstant: {
        CREATE_SWIPEMACHINE: "CREATE_ SWIPEMACHINE",
        SWIPEMACHINE_CREATED: " SWIPEMACHINE_CREATED",
        SWIPEMACHINE_CREATION_FAILED: " SWIPEMACHINE_CREATION_FAILED",
        FETCHED_ALL_SWIPEMACHINE: "FETCHED_ALL_SWIPEMACHINE",
        SWIPEMACHINE_FETCH_FAILED: "SWIPEMACHINE_FETCH_FAILED",
        SWIPEMACHINEE_STORE_CHANGE: "SWIPEMACHINE_STORE_CHANGE"
    },
    notificationConstant: {
        FETCHED_ALL_NOTIFICATION: "FETCHED_ALL_NOTIFICATION",
        NOTIFICATION_FETCH_FAILED: "NOTIFICATION_FETCH_FAILED"
    },
    creditDetailConstant: {
        CREAT_CREDITDETAIL: "CREAT_CREDITDETAIL",
        CREDITDETAIL_CREATED: "CREDITDETAIL_CREATED",
        CREDITDETAIL_CREATION_FAILED: "CREDITDETAIL_CREATION_FAILED",

        CREDITDETAIL_FETCH_FAILED: "CREDITDETAIL_FETCH_FAILED",
        CREDITDETAIL_FETCH_ALL: "CREDITDETAIL_FETCH_ALL",

        CREDITDETAIL_STORE_CHANGE: "CREDITDETAIL_STORE_CHANGE"
    }




};

export const mpdConstant = constants.mpdConstant;
export const nozzelConstant = constants.nozzelConstant;
export const productConstant = constants.productConstant;
export const tankConstant = constants.tankConstant;
export const stockInConstant = constants.stockInConstant;
export const invoiceConstant = constants.invoiceConstant;
export const userConstant = constants.userConstant;
export const shiftConstant = constants.shiftConstant;
export const employeeConstant = constants.employeeConstant;
export const employeeAdvanceConstant = constants.employeeAdvance;
export const creditorConstant = constants.creditorConstant;
export const productRateConstant = constants.productRateConstant;
export const expenditureCatagoryConstant = constants.expenditureCatagoryConstant;
export const transactionAccountConstant = constants.transactionAccountConstant;
export const paymentModeConstant = constants.paymentModeConstant;
export const swipeMachineConstant = constants.swipeMachineConstant;
export const notificationConstant = constants.notificationConstant;
export const creditDetailConstant = constants.creditDetailConstant;


// WEBPACK FOOTER //
// ./src/jsx/constants/constants.jsx